import {
    FETCH_PRINTER_CATEGORIES_START,
    FETCH_PRINTER_CATEGORIES_SUCCESS,
    FETCH_PRINTER_CATEGORIES_ERROR,
    CREATE_PRINTER_CATEGORY_START,
    CREATE_PRINTER_CATEGORY_SUCCESS,
    CREATE_PRINTER_CATEGORY_ERROR,
    UPDATE_PRINTER_CATEGORY_START,
    UPDATE_PRINTER_CATEGORY_SUCCESS,
    UPDATE_PRINTER_CATEGORY_ERROR,
    DELETE_PRINTER_CATEGORY_START,
    DELETE_PRINTER_CATEGORY_SUCCESS,
    DELETE_PRINTER_CATEGORY_ERROR,
    SET_PRINTER_FILTERS,
    CLEAR_PRINTER_FILTERS
} from '../actions';

const initialState = {
    categories: [],
    loading: false,
    error: null,
    pagination: {
        current: 1,
        pageSize: 10,
        total: 0
    },
    filters: {
        searchText: '',
        statusFilter: 'all',
        codeFilter: 'all'
    }
};

const printerCategoriesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PRINTER_CATEGORIES_START:
        case CREATE_PRINTER_CATEGORY_START:
        case UPDATE_PRINTER_CATEGORY_START:
        case DELETE_PRINTER_CATEGORY_START:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_PRINTER_CATEGORIES_SUCCESS:
            return {
                ...state,
                categories: action.payload.categories || [],
                pagination: action.payload.pagination || state.pagination,
                loading: false,
                error: null
            };

        case CREATE_PRINTER_CATEGORY_SUCCESS:
            return {
                ...state,
                categories: [...state.categories, action.payload],
                loading: false,
                error: null
            };

        case UPDATE_PRINTER_CATEGORY_SUCCESS:
            return {
                ...state,
                categories: state.categories.map(category =>
                    category.id === action.payload.id ? action.payload : category
                ),
                loading: false,
                error: null
            };

        case DELETE_PRINTER_CATEGORY_SUCCESS:
            return {
                ...state,
                categories: state.categories.filter(category => category.id !== action.payload),
                loading: false,
                error: null
            };

        case SET_PRINTER_FILTERS:
            return {
                ...state,
                filters: { ...state.filters, ...action.payload }
            };

        case CLEAR_PRINTER_FILTERS:
            return {
                ...state,
                filters: {
                    searchText: '',
                    statusFilter: 'all',
                    codeFilter: 'all'
                }
            };

        case FETCH_PRINTER_CATEGORIES_ERROR:
        case CREATE_PRINTER_CATEGORY_ERROR:
        case UPDATE_PRINTER_CATEGORY_ERROR:
        case DELETE_PRINTER_CATEGORY_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        default:
            return state;
    }
};

export default printerCategoriesReducer;